export const MODULE_SPACINGS = {
  hero: { xl: 0, lg: 0, md: 0, sm: 0 },
  story_telling: { xl: 32, lg: 24, md: 20, sm: 16 },
  non_story_telling: { xl: 64, lg: 56, md: 40, sm: 32 },
  no_space: { xl: 0, lg: 0, md: 0, sm: 0 },
};

export const MODULE_TYPES = {
  hero: 'hero',
  story_telling: 'story_telling',
  non_story_telling: 'non_story_telling',
  no_space: 'no_space',
};
